import React, { useState } from 'react'
import { Sidebar } from './components/layout/Sidebar'
import { Header } from './components/layout/Header'
import { DebugTools } from './components/debug/DebugTools'
import { Settings } from 'lucide-react'
import { ScreenWrapper } from './components/layout/ScreenWrapper'
import { StoryModal } from './components/modals/StoryModal'
import { useGameplayContext } from './contexts/gameplayContext'
import { TourProvider } from '@reactour/tour'
import { isProductionBuild } from './utils'
import { WelcomeBackScreen } from './components/WelcomeBackScreen'
import { StokeCatchingGame } from './components/StokeCatchingGame'

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const [isDebugOpen, setIsDebugOpen] = useState(false)
  const { showStoryModal, setShowStoryModal, gameData } = useGameplayContext()

  const handleStoryModalClose = () => {
    setShowStoryModal(false)
  }

  return (
    <TourProvider steps={[]}>
      <div className="flex flex-col h-screen bg-gradient-to-br from-cyan-500 to-blue-500 overflow-hidden font-surf">
        <div className="absolute inset-0 bg-[url('/assets/wave-bg.jpg')] opacity-10 bg-cover bg-center" />

        <Header setIsSidebarOpen={setIsSidebarOpen} />

        <div className="flex flex-1 overflow-hidden">
          <Sidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />

          <main className="flex-1 overflow-y-auto p-4 relative">
            <div className="relative z-10">
              <ScreenWrapper>{children}</ScreenWrapper>
            </div>
          </main>

          <DebugTools isDebugOpen={isDebugOpen} setIsDebugOpen={setIsDebugOpen} />
        </div>

        {/* Debug Tools Toggle Button */}
        {!isProductionBuild() && (
          <button
            className="fixed bottom-4 right-4 bg-yellow-400 hover:bg-yellow-500 text-blue-900 p-2 rounded-full shadow-lg z-50 transition-colors"
            onClick={() => setIsDebugOpen(!isDebugOpen)}
          >
            <Settings className="w-6 h-6" />
          </button>
        )}
        {showStoryModal && <StoryModal onClose={handleStoryModalClose} />}

        <WelcomeBackScreen />

        {/* Render StokeCatchingGame only when surfing */}
        {gameData.currentActivity === 'surf' && <StokeCatchingGame />}
      </div>
    </TourProvider>
  )
}

export default Layout
